import React, { Fragment } from 'react';

import PagesRecoverPasswordContent from '../../example-components/PagesRecoverPassword/PagesRecoverPasswordContent';
export default function PagesRecoverPassword() {
  return (
    <Fragment>
      <PagesRecoverPasswordContent />
    </Fragment>
  );
}
